// src/utils/employeeRate.js
//
// Эффективная ставка сотрудника.
//
// Правило домена: ставка привязана к КАЖДОЙ должности, а не к
// сотруднику целиком. Должности хранятся в employee.departments:
//   - primary: true  - основная, ставка не редактируется, эффективно 1;
//   - primary: false - совмещение, у каждой записи своя ставка rate;
//   - deptId: null   - должность без привязки к отделу (та же семантика
//                      не-primary, что и у обычного совмещения).
//
// Правила:
//   - нет ни одной должности     → 1;
//   - есть хоть одна primary     → 1 (primary «бьёт» сумму совмещений);
//   - все совмещения             → min(1, Σ rate_i) с дефолтом rate=1
//                                  для записей, где поле не задано.
//
// Таблица примеров:
//
//   | departments                                        | eff. rate |
//   |----------------------------------------------------|-----------|
//   | 1.0 основная + 0.5 совмещение                      |   1.0     |
//   | нет основной, одно совмещение 0.5                  |   0.5     |
//   | нет основной, 0.5 + 0.3                            |   0.8     |
//   | нет основной, 0.7 + 0.5                            |   1.0     |
//   | нет ни одной должности                             |   1.0     |
//   | ГК КБ с совмещением 0.5                            |   0.5     |
//   | (ГК - kb_chief, у него departments = только совм.) |           |
//
// Чистая функция: только переданные данные, без обращений к репозиториям.

/**
 * Эффективная ставка сотрудника.
 * @param {{ departments?: Array<{ primary?: boolean, rate?: number }> }} employee
 * @returns {number} число в диапазоне [0.1, 1] либо 1.
 */
export function effectiveEmployeeRate(employee) {
  const deps = employee?.departments ?? [];
  if (deps.length === 0) return 1;
  if (deps.some((d) => d.primary)) return 1;

  let sum = 0;
  for (const d of deps) {
    const r = d?.rate ?? 1;
    if (Number.isFinite(r) && r > 0) sum += r;
  }
  return Math.min(1, sum);
}

/**
 * Сотрудник на неполной ставке.
 * @param {object} employee
 * @returns {boolean}
 */
export function isPartTime(employee) {
  return effectiveEmployeeRate(employee) < 1;
}
